export default {"src":"/_next/static/media/plan.14ed28a4.svg","height":26,"width":26,"blurWidth":0,"blurHeight":0};